<template>
  <button
    ref="buttonFocus"
    class="btn btn-primary btnMain"
    :class="disabled ? '' : 'border-0'"
    type="button"
    :disabled="disabled"
    :isFocus="isFocus"
    @click="$emit('click')"
  >
    <img v-show="imgURL != null" :src="imgURL" />
    {{ buttonName }}
    <img v-show="openImg != null" :src="openImg" />
  </button>
</template>

<script>
export default {
  name: 'ButtonMain',
  props: {
    // フォーカスフラグ
    isFocus: {
      type: Boolean,
      default: false
    },
    buttonName: String,
    disabled: Boolean,
    imgURL: String,
    openImg: String
  },
  watch: {
    isFocus: {
      deep: true,
      handler(val) {
        if (val === true) {
          this.focus()
        }
      }
    }
  },
  mounted() {
    this.focus()
  },
  methods: {
    focus() {
      if (this.isFocus === true) {
        this.$nextTick(() => {
          setTimeout(() => {
            if (this.$refs.buttonFocus && !this.$refs.buttonFocus.value) {
              this.$refs.buttonFocus.focus()
            }
          }, 800)
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.btnMain {
  background-color: rgb(35, 78, 165);
  color: rgb(255, 255, 255);
  min-width: 80px;

  height: 25px;
  font-size: 14px;
  padding: 0 1em;
}
.btnMain:hover {
  filter: opacity(70%);
}
button:disabled {
  color: rgb(154, 154, 154);
  background-color: rgb(225, 225, 225);
  border-radius: 4px;
  border-color: rgb(154, 154, 154);
  border: none;
}
</style>
